import { Common } from '~/models/common';
import { Messengers } from '~/models/messengers';

export const messengersService = {
	fetch: async (): Promise<Messengers.Model[]> => {
		const params = {
			filter: {
				status: Common.Status.PUBLISHED,
			},
		};

		try {
			const response = await $fetch<Messengers.Model[]>(Messengers.api, {
				method: 'POST',
				body: { params },
			});

			return response;
		} catch (error) {
			console.error('Failed to fetch Messengers:', error);

			return [];
		}
	},
};
